import classNames from 'classnames';
import IconLegend from './ui/IconLegend';
import React, { useEffect, useState } from 'react'
import { IoCloseCircle } from 'react-icons/io5';
import { sideMenuState } from '../state/sideMenuState';
import { sortBy } from 'lodash';
import { tariffarioState } from '../state/tariffarioState';
import { useRecoilValue, useRecoilState } from 'recoil';

export const SideMenu = () => {
    const sezioni = useRecoilValue(tariffarioState);
    const [stick, setStick] = useState();
    const [selected, setSelected] = useRecoilState(sideMenuState);

    useEffect(() => {
        window.addEventListener("scroll", StickMenu);
    }, []);

    const StickMenu = () => {
        var y = window.scrollY;
        setStick(y >= 600)
    }

    function _scrollTo(selector, yOffset = 0) {
        const el = document.querySelector(selector);
        const y = el.getBoundingClientRect().top /* + window.pageYOffset */ + yOffset ;

        window.scrollTo({ top: y, behavior: 'smooth' });
    }

    const onClick = (e, index) => {
        e.preventDefault();
        setSelected(index);
		_scrollTo(`#tariffario`, 0); // Precedente: sezione_${index}, 480
    }


    const result = sortBy(sezioni.map((item, index) => {
        return { ...item, startingIndex: index }
    }), 'DescrizioneBreve');


    return (
        <div id="menu_fix" className={classNames({ sticky: true, top: !stick, stick: stick })}>
            <IconLegend />

            <p style={{ color: '#2e333a', textAlign: "left", borderBottom: '2px solid #6abb90' }}> <b>Nomenclatore Tariffario</b></p>
            <ul>
                {result.map((sezione, index) => (
                    <li className="indice" key={`sezione_${sezione.startingIndex}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                        <a className='ancora'
                            style={{ cursor: 'pointer', color: selected !== sezione.startingIndex && !!selected ? '#ccc' : undefined }}
                            onClick={(e) => onClick(e, sezione.startingIndex)}>
                            {sezione.DescrizioneBreve}
                        </a>

                        {selected === sezione.startingIndex && <span style={{ cursor: 'pointer' }} onClick={() => setSelected(undefined)}><IoCloseCircle style={{ color: '#6abb90' }} /></span>}

                    </li>
                ))}
            </ul>
        </div>
    )
}
